import { SAVE_DETAILS, CLEAR_DETAILS } from '../actions/PrintActions';

export const print = (state = null, actions) => {
  switch (actions.type) {
    case SAVE_DETAILS:
      return Object.assign({}, state, { from: actions.from, to: actions.to, order: actions.order });
    case CLEAR_DETAILS:
      return Object.assign({}, state, {});
    default:
      return state;
  }
}

export default print;


// WEBPACK FOOTER //
// ./src/reducers/print.js